module.exports = __webpack_public_path__ + "static/skitrip4-7a7384dbcacc13c26761230d919624c2.png";